import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "col-md-12" }
const _hoisted_2 = { class: "row" }
const _hoisted_3 = { class: "col-md-4" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("h5", null, "Shipping Address", -1)
const _hoisted_5 = { key: 0 }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_7 = { key: 1 }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_9 = { key: 2 }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_11 = { key: 3 }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_13 = { key: 4 }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_15 = { key: 5 }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_17 = {
  key: 0,
  class: "col-md-4"
}
const _hoisted_18 = /*#__PURE__*/_createElementVNode("h5", null, "Payment Information", -1)
const _hoisted_19 = { key: 0 }
const _hoisted_20 = {
  key: 1,
  class: "col-md-4 text-right"
}
const _hoisted_21 = /*#__PURE__*/_createTextVNode(" Winning Bid: ")
const _hoisted_22 = { class: "order-total" }
const _hoisted_23 = { class: "col-md-4 text-right" }
const _hoisted_24 = { key: 0 }
const _hoisted_25 = /*#__PURE__*/_createTextVNode(" Order Total: ")
const _hoisted_26 = { class: "order-total" }
const _hoisted_27 = { class: "row" }
const _hoisted_28 = { class: "row items" }
const _hoisted_29 = { class: "col-md-8" }
const _hoisted_30 = { class: "row" }
const _hoisted_31 = {
  xs: "4",
  class: "col-md-3"
}
const _hoisted_32 = {
  key: 0,
  class: "image"
}
const _hoisted_33 = ["src"]
const _hoisted_34 = { key: 1 }
const _hoisted_35 = ["src", "onError"]
const _hoisted_36 = {
  xs: "8",
  class: "col-md-9"
}
const _hoisted_37 = { class: "description" }
const _hoisted_38 = { class: "item-description mb-2" }
const _hoisted_39 = { class: "list-unstyled" }
const _hoisted_40 = {
  key: 0,
  class: "price"
}
const _hoisted_41 = {
  key: 1,
  class: "price"
}
const _hoisted_42 = { class: "col-md-4 text-right status-wrap" }
const _hoisted_43 = { class: "status" }
const _hoisted_44 = /*#__PURE__*/_createTextVNode(" Order Again ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_b_accordion_item = _resolveComponent("b-accordion-item")!
  const _component_b_accordion = _resolveComponent("b-accordion")!

  return (_ctx.orders?.length && _ctx.orders?.length > 0)
    ? (_openBlock(), _createBlock(_component_b_accordion, {
        key: 0,
        free: "",
        class: "v-accordion"
      }, {
        default: _withCtx(() => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.orders, (order) => {
            return (_openBlock(), _createBlock(_component_b_accordion_item, {
              key: order.id,
              title: 'Order #: ' + order.id + ' ' + _ctx.createAt(order.created_at)
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_1, [
                  _createElementVNode("div", _hoisted_2, [
                    _createElementVNode("div", _hoisted_3, [
                      _hoisted_4,
                      (order?.shippingAddress?.addr1)
                        ? (_openBlock(), _createElementBlock("p", _hoisted_5, [
                            _createTextVNode(_toDisplayString(order?.shippingAddress?.addr1), 1),
                            _hoisted_6
                          ]))
                        : _createCommentVNode("", true),
                      (order?.shippingAddress?.addr2)
                        ? (_openBlock(), _createElementBlock("p", _hoisted_7, [
                            _createTextVNode(_toDisplayString(order?.shippingAddress?.addr2), 1),
                            _hoisted_8
                          ]))
                        : _createCommentVNode("", true),
                      (order?.shippingAddress?.city)
                        ? (_openBlock(), _createElementBlock("p", _hoisted_9, [
                            _createTextVNode(_toDisplayString(order?.shippingAddress?.city), 1),
                            _hoisted_10
                          ]))
                        : _createCommentVNode("", true),
                      (order?.shippingAddress?.postal_code)
                        ? (_openBlock(), _createElementBlock("p", _hoisted_11, [
                            _createTextVNode(_toDisplayString(order?.shippingAddress?.postal_code), 1),
                            _hoisted_12
                          ]))
                        : _createCommentVNode("", true),
                      (order?.shippingAddress?.state_or_province)
                        ? (_openBlock(), _createElementBlock("p", _hoisted_13, [
                            _createTextVNode(_toDisplayString(order?.shippingAddress?.state_or_province), 1),
                            _hoisted_14
                          ]))
                        : _createCommentVNode("", true),
                      (order?.shippingAddress?.zip)
                        ? (_openBlock(), _createElementBlock("p", _hoisted_15, [
                            _createTextVNode(_toDisplayString(order?.shippingAddress.zip), 1),
                            _hoisted_16
                          ]))
                        : _createCommentVNode("", true)
                    ]),
                    (order.paymentSource)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                          _hoisted_18,
                          _createElementVNode("p", null, [
                            _createTextVNode(_toDisplayString(order.paymentSource.name) + " ", 1),
                            (order.paymentSource.name === 'PO')
                              ? (_openBlock(), _createElementBlock("span", _hoisted_19, ": " + _toDisplayString(order.paymentSource.id), 1))
                              : _createCommentVNode("", true)
                          ])
                        ]))
                      : _createCommentVNode("", true),
                    (order?.referral_type_id === '4')
                      ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                          _createElementVNode("h5", null, [
                            _hoisted_21,
                            _createElementVNode("span", _hoisted_22, "$" + _toDisplayString(order.order_subtotal), 1)
                          ])
                        ]))
                      : _createCommentVNode("", true),
                    _createElementVNode("div", _hoisted_23, [
                      (order?.referral_type_id !== '5' && order?.referral_type_id !== '4')
                        ? (_openBlock(), _createElementBlock("h5", _hoisted_24, [
                            _hoisted_25,
                            _createElementVNode("span", _hoisted_26, "$" + _toDisplayString(order?.order_subtotal), 1)
                          ]))
                        : _createCommentVNode("", true)
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_27, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(order?.items, (item) => {
                    return (_openBlock(), _createElementBlock("div", {
                      class: "col-md-12 text-right",
                      key: item?.item?.id
                    }, [
                      _createElementVNode("div", _hoisted_28, [
                        _createElementVNode("div", _hoisted_29, [
                          _createElementVNode("div", _hoisted_30, [
                            _createElementVNode("div", _hoisted_31, [
                              (item?.item?.images[0] && item?.item?.images[0]?.path)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_32, [
                                    _createElementVNode("img", {
                                      src: item?.item?.images[0]?.path,
                                      alt: "Item Image"
                                    }, null, 8, _hoisted_33)
                                  ]))
                                : (_openBlock(), _createElementBlock("div", _hoisted_34, [
                                    _createElementVNode("img", {
                                      alt: "Item Image",
                                      src: require('@/static/images/generic.jpeg'),
                                      onError: (e) => e.target.src = require('@/static/images/generic.jpeg')
                                    }, null, 40, _hoisted_35)
                                  ]))
                            ]),
                            _createElementVNode("div", _hoisted_36, [
                              _createElementVNode("div", _hoisted_37, [
                                _createElementVNode("p", _hoisted_38, _toDisplayString(item?.item?.product?.product_description), 1),
                                _createElementVNode("ul", _hoisted_39, [
                                  _createElementVNode("li", null, "Model/MPN: " + _toDisplayString(item?.item?.product?.mpn), 1),
                                  _createElementVNode("li", null, "Quantity: " + _toDisplayString(item?.quantity), 1)
                                ]),
                                (item?.item?.sell_price)
                                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                      (order?.referral_type_id !== '5' && order?.referral_type_id !== '4')
                                        ? (_openBlock(), _createElementBlock("p", _hoisted_40, " $" + _toDisplayString(item?.item?.sell_price.toFixed(2)), 1))
                                        : _createCommentVNode("", true)
                                    ], 64))
                                  : _createCommentVNode("", true),
                                (order?.referral_type_id === '4')
                                  ? (_openBlock(), _createElementBlock("p", _hoisted_41, " This item was part of a lot which was won at auction. "))
                                  : _createCommentVNode("", true)
                              ])
                            ])
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_42, [
                          _createElementVNode("p", _hoisted_43, "Order Status: " + _toDisplayString(item?.item?.status), 1),
                          (item?.item?.id)
                            ? (_openBlock(), _createBlock(_component_router_link, {
                                key: 0,
                                to: { name: _ctx.PRODUCT, params: { id: item?.item?.id } },
                                class: "btn btn-dark order-again"
                              }, {
                                default: _withCtx(() => [
                                  _hoisted_44
                                ]),
                                _: 2
                              }, 1032, ["to"]))
                            : _createCommentVNode("", true)
                        ])
                      ])
                    ]))
                  }), 128))
                ])
              ]),
              _: 2
            }, 1032, ["title"]))
          }), 128))
        ]),
        _: 1
      }))
    : _createCommentVNode("", true)
}